var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJourneyPlanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "f9a28cfb-c2ad-4d05-b76c-c168906c07cb",
    d: "M7.816 9.413C3.498 9.413 0 13.073 0 17.585 0 23.942 7.816 31 7.816 31s7.818-7.058 7.818-13.415c0-4.512-3.499-8.172-7.818-8.172zm0 13.317c-2.936 0-5.317-2.42-5.317-5.408 0-2.986 2.38-5.407 5.317-5.407 2.937 0 5.319 2.42 5.319 5.407s-2.382 5.408-5.319 5.408zm18.078-6.391s5.374-4.852 5.374-9.22c0-3.104-2.406-5.619-5.374-5.619-2.97 0-5.374 2.515-5.374 5.618 0 4.37 5.374 9.221 5.374 9.221zm-3.656-9.402c0-2.052 1.637-3.717 3.656-3.717s3.656 1.664 3.656 3.717c0 2.054-1.637 3.718-3.656 3.718s-3.656-1.665-3.656-3.718zm3.656-1.48c.809 0 1.466.663 1.466 1.483 0 .82-.657 1.484-1.466 1.484-.81 0-1.466-.664-1.466-1.484s.657-1.483 1.466-1.483zm1.087 23.986h-1.008v1.484l1.07-.003c.362-.03.705-.08 1.025-.148l-.3-1.453c-.267.057-.55.097-.787.12zm-3.94 0h1.955v1.484h-1.954v-1.484zm-2.93 0h1.954v1.484H20.11v-1.484zm-2.932 0h1.954v1.484H17.18v-1.484zm-2.93 0h1.954v1.484h-1.955v-1.484zM9.77 30.927h3.5v-1.484h-1.954l-1.546 1.484zm18.809-1.848l.545 1.379c.771-.31 1.4-.774 1.867-1.375l-1.151-.92c-.31.399-.723.698-1.261.916zm1.954-3.251c-.012.64-.115 1.2-.305 1.663l1.355.567c.26-.635.4-1.375.416-2.202l-1.466-.028zm1.413-1.065c-.101-.834-.353-1.565-.744-2.167l-1.225.813c.267.412.441.928.515 1.537l1.454-.183zm-3.926-2.641c.587.154 1.076.392 1.45.71l.944-1.133c-.542-.463-1.225-.803-2.027-1.013l-.367 1.436zm-.858-.159l.162-1.473-2.034-.03v1.483l1.628-.002.244.022zM22.36 20.46h1.954v1.483H22.36V20.46zm-.977 1.483v-1.484l-1.305.003a4.79 4.79 0 0 1-.5-.068l-.287 1.455c.209.043.428.073.725.096l1.367-.002zm-3.212-.487l.686-1.31c-.419-.225-.673-.557-.805-1.048l-1.413.39c.236.886.751 1.548 1.532 1.968zm.144-4.584l-1.187-.87c-.424.593-.638 1.358-.638 2.312l1.466-.038c0-.598.12-1.07.36-1.404zm1.7-.781h.313v-1.484l-.374.002c-.734.06-1.364.24-1.871.532l.725 1.29c.322-.184.748-.3 1.208-.34zm1.291 0h2.932l-1.55-1.484h-1.382v1.484z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bf9a28cfb-c2ad-4d05-b76c-c168906c07cb",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f9a28cfb-c2ad-4d05-b76c-c168906c07cb"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#f9a28cfb-c2ad-4d05-b76c-c168906c07cb"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#bf9a28cfb-c2ad-4d05-b76c-c168906c07cb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyPlanner);
export default __webpack_public_path__ + "static/media/journey-planner.0cbd1a83eb1e21aeef15d170258564a2.svg";
export { ForwardRef as ReactComponent };